import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";

import "./styles.scss";

export const TutorialPortal = ({
  arrowPosition,
  children,
  className,
  mobileSubText,
  onSecondarySubmit,
  secondaryButtonText,
  secondaryButtonTextMobile,
  subText,
  title,
  ...props
}) => {
  if (!mobileSubText) {
    mobileSubText = subText;
  }

  return (
    <div className={createClassNameString(["apti-TutorialPortal", className, arrowPosition])}>
      <p className="apti-TutorialPortal--title">{title}</p>
      <p className="apti-TutorialPortal--subText">{subText}</p>
      <p className="apti-TutorialPortal--mobileSubText">{mobileSubText}</p>
      <div>
        {children}
        {secondaryButtonText && (
          <p className="apti-TutorialPortal--skip" onClick={onSecondarySubmit}>
            {secondaryButtonText}
          </p>
        )}
        {secondaryButtonTextMobile && (
          <p className="apti-TutorialPortal--skip--mobile" onClick={onSecondarySubmit}>
            {secondaryButtonTextMobile}
          </p>
        )}
      </div>
    </div>
  );
};

TutorialPortal.propTypes = {
  arrowPosition: PropTypes.string,
  children: PropTypes.element,
  mobileSubText: PropTypes.string,
  onSecondarySubmit: PropTypes.func,
  primaryButtonComponent: PropTypes.element,
  secondaryButtonText: PropTypes.string,
  secondaryButtonTextMobile: PropTypes.string,
  subText: PropTypes.string,
  title: PropTypes.string,
};

TutorialPortal.defaultProps = {
  arrowPosition: "null",
  children: <></>,
  className: undefined,
  mobileSubText: null,
  onSecondarySubmit: () => {},
  secondaryButtonText: "",
  secondaryButtonTextMobile: "",
  subText: "",
  title: "",
};
